import React, { useState } from 'react';
import './ContextViewer.css';

const ContextViewer = ({ contextItems, isOpen, onClose }) => {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpanded = (itemId) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const formatTimestamp = (timestamp) => {
    return new Date(timestamp).toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const getRoleIcon = (role) => {
    switch (role) {
      case 'user':
        return '👤';
      case 'assistant':
        return '🤖';
      default:
        return '📝';
    }
  };

  const getRoleLabel = (role) => {
    switch (role) {
      case 'user':
        return 'Usuário';
      case 'assistant':
        return 'Assistente IA';
      default:
        return 'Sistema';
    }
  };

  const getTypeLabel = (type) => {
    switch (type) {
      case 'content':
        return 'Conteúdo';
      case 'system':
        return 'Sistema';
      default:
        return type || 'Desconhecido';
    }
  };

  const formatContent = (data, type) => {
    if (!data) return 'Sem conteúdo';
    
    try {
      // Try to parse as JSON for better formatting
      const parsed = JSON.parse(data);
      return JSON.stringify(parsed, null, 2);
    } catch {
      // If not JSON, return as is
      return data;
    }
  };

  if (!isOpen) return null;

  return (
    <div className="context-viewer-overlay">
      <div className="context-viewer">
        <div className="context-viewer-header">
          <h3>Contexto da Conversa</h3>
          <div className="context-viewer-actions">
            <span className="context-count">
              {contextItems?.length || 0} mensagens
            </span>
            <button 
              className="close-btn"
              onClick={onClose}
              title="Fechar"
            >
              ✕
            </button>
          </div>
        </div>
        
        <div className="context-viewer-content">
          {!contextItems || contextItems.length === 0 ? (
            <div className="empty-context">
              <div className="empty-icon">💬</div>
              <p>Nenhum contexto disponível</p>
            </div>
          ) : (
            <div className="context-items">
              {contextItems.map((item, index) => {
                const isExpanded = expandedItems[item.id];
                const content = formatContent(item.data, item.type);
                
                return (
                  <div key={item.id} className="context-item">
                    <div 
                      className="context-item-header"
                      onClick={() => toggleExpanded(item.id)}
                    >
                      <div className="context-item-info">
                        <span className="role-icon">{getRoleIcon(item.role)}</span>
                        <div className="context-item-details">
                          <div className="context-item-meta">
                            <span className="role-label">{getRoleLabel(item.role)}</span>
                            <span className="type-label">{getTypeLabel(item.type)}</span>
                            <span className="timestamp">{formatTimestamp(item.createdAt)}</span>
                          </div>
                          <div className="context-item-preview">
                            {content.length > 100 ? 
                              `${content.substring(0, 100)}...` : 
                              content
                            }
                          </div>
                        </div>
                      </div>
                      <div className="expand-icon">
                        {isExpanded ? '▼' : '▶'}
                      </div>
                    </div>
                    
                    {isExpanded && (
                      <div className="context-item-content">
                        <div className="content-header">
                          <span>Conteúdo completo:</span>
                          <button 
                            className="copy-btn"
                            onClick={() => {
                              navigator.clipboard.writeText(content);
                              // You could add a toast notification here
                            }}
                            title="Copiar conteúdo"
                          >
                            📋 Copiar
                          </button>
                        </div>
                        <pre className="content-text">{content}</pre>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        
        <div className="context-viewer-footer">
          <div className="context-info">
            <small>
              Este contexto mostra todas as mensagens trocadas entre o usuário e a IA durante o processamento.
              Útil para auditoria e resolução de problemas.
            </small>
          </div>
          <button 
            className="btn btn-secondary"
            onClick={onClose}
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContextViewer;
